import { BRANDING_NAME_QUERY_PARAM, INVITE_TYPE_QUERY_PARAM } from './constants';

export const extractEmailFromReferrer = (referrer) => {
    try {
        const url = new URL(referrer, window.location.origin);
        const email = url.searchParams.get('username');
        return email ? decodeURIComponent(email) : '';
    } catch (error) {
        console.error('Invalid URL:', error);
        return '';
    }
};

export const extractInviteTypeFromReferrer = (referrer) => {
    try {
        const url = new URL(referrer, window.location.origin);
        const inviteType = url.searchParams.get(INVITE_TYPE_QUERY_PARAM);
        return inviteType ? decodeURIComponent(inviteType) : '';
    } catch (error) {
        console.error('Invalid URL:', error);
        return '';
    }
};

export const extractBrandingNameFromReferrer = (referrer: string): string => {
    try {
        const url = new URL(referrer, window.location.origin);
        const brandingName = url.searchParams.get(BRANDING_NAME_QUERY_PARAM);
        return brandingName ? decodeURIComponent(brandingName) : '';
    } catch (error) {
        console.error('Invalid URL:', error);
        return '';
    }
};
